import Siema from 'siema'

const slider = document.querySelector('.js-slider')

if (slider) {
  const sliderContainer = slider.querySelector('.js-slider-container')

  window.addEventListener('load', () => {
    const sliderNavigation = document.querySelector('.js-slider-nav')
    let timeout = null

    slider.classList.add('has-loaded')

    const siema = new Siema({
      duration: 600,
      easing: 'ease-in-out',
      loop: true,
      selector: sliderContainer,
      onChange () {
        this.config.buttons.forEach(item => item.classList.remove('is-active'))
        this.config.buttons[this.currentSlide].classList.add('is-active')

        clearTimeout(timeout)
        timeout = setTimeout(() => siema.next(), this.config.timeout)
      }
    })

    siema.config.buttons = []
    siema.config.timeout = 5000

    for (let i = 0; i < siema.innerElements.length; i++) {
      const button = document.createElement('button')
      button.setAttribute('aria-label', `Zu Bild ${i + 1} wechseln`)
      button.classList.add('slider__button')

      if (siema.currentSlide === i) {
        button.classList.add('is-active')
      }

      button.addEventListener('click', () => siema.goTo(i))

      sliderNavigation.appendChild(button)
      siema.config.buttons.push(button)
    }

    timeout = setTimeout(() => siema.next(), siema.config.timeout)
  })
}



// WEBPACK FOOTER //
// ./src/components/slider/scripts.js